interface BrokerUnassignedProps {
  width: string;
  height: string;
}

export default function BrokerUnassigned(props: BrokerUnassignedProps) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width}
        height={props.height}
        viewBox="0 0 52 52"
        fill="none"
      >
        <rect x="3" y="3" width="46" height="46" rx="23" fill="#fff" />
        <rect x="3" y="3" width="46" height="46" rx="23" stroke="#002035" strokeWidth="2" />
        <path
          d="M43.467 40.511A22.735 22.735 0 1 0 3.25 26a22.586 22.586 0 0 0 5.283 14.511l-.033.028c.114.136.244.253.361.388.146.168.304.325.455.488.455.494.923.968 1.414 1.413.15.137.304.264.455.394.52.448 1.054.874 1.609 1.27.071.05.136.113.208.163v-.02a22.59 22.59 0 0 0 26 0v.02c.071-.05.134-.114.208-.163a23.48 23.48 0 0 0 1.608-1.27c.151-.13.306-.259.455-.394.491-.446.96-.92 1.414-1.413.151-.163.307-.32.455-.488.115-.135.247-.252.36-.39l-.035-.026zM26 13a7.312 7.312 0 1 1 0 14.625A7.312 7.312 0 0 1 26 13zM13.011 40.511a8.119 8.119 0 0 1 8.114-8.011h9.75a8.119 8.119 0 0 1 8.114 8.011 19.403 19.403 0 0 1-25.978 0z"
          fill="#002035"
          fillOpacity=".5"
        />
        <g clipPath="url(#vdtyotpkda)">
          <rect x="34" y="34" width="16" height="16" rx="8" fill="#FCF6EB" />
          <path
            d="M42 34c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm.8 13.6h-1.6V46h1.6v1.6zm1.656-6.2-.72.736c-.576.584-.936 1.064-.936 2.264h-1.6V44c0-.88.36-1.68.936-2.264l.992-1.008c.296-.288.472-.688.472-1.128 0-.88-.72-1.6-1.6-1.6-.88 0-1.6.72-1.6 1.6h-1.6a3.2 3.2 0 1 1 6.4 0c0 .704-.288 1.344-.744 1.8z"
            fill="#FC4C4C"
          />
        </g>
        <rect x="33.5" y="33.5" width="17" height="17" rx="8.5" stroke="#FCF6EB" />
        <defs>
          <clipPath id="vdtyotpkda">
            <rect x="34" y="34" width="16" height="16" rx="8" fill="#fff" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
